import { uid } from '../../../../lib/uid';

/**
 * Test data backing the Autogenerate button on the classification form.
 *
 * Fills every required field so the primary action enables on the first try, and the
 * definition too — a classification with no definition is the one thing a reader choosing
 * between two of them actually needs. Keep it in lockstep with the form: a new required field
 * must be added here in the same change, or Autogenerate silently stops working.
 *
 * Values are synthetic vocabulary. A classification name never leaves `rsys_` and never lands
 * in the identity store, so plausible wording is right here — the rule about obviously-fake
 * values is about where a value LANDS, and `samplePersonnel` is the case that governs.
 *
 * Deliberately NOT the matrix's own four: those are seeded on boot, and generating one would
 * collide with a live row on the first click.
 */

const TIERS = [
  'Restricted',
  'Regulated',
  'Supplier Confidential',
  'Board Confidential',
  'Personnel Confidential',
  'Legally Privileged',
];

const DEFINITIONS = [
  'Access is limited to the named recipients. Disclosure outside them requires the owner’s written approval.',
  'Held under a statutory or contractual obligation. Retention and disposal follow the governing instrument rather than the default schedule.',
  'Shared under a non-disclosure agreement. The original must not be altered without the counterparty’s written permission.',
  'Prepared for a governing body. Circulation outside the meeting record is not permitted.',
];

/**
 * One classification.
 *
 * The name carries a suffix because it is unique among the ACTIVE rows, and Autogenerate is
 * most useful clicked repeatedly — without one the second click would produce a name the
 * server rejects as a duplicate.
 *
 * **The confidential flag is deliberately left at its default.** It decides whether documents
 * under this classification are refused into a shared folder, so generating it would make the
 * same button produce a materially different rule on each click — the unpredictability the
 * flag rule exists to prevent. It is one tick for a reader who wants the other value.
 */
export function sampleClassification(): { name: string; description: string } {
  const name = TIERS[Math.floor(Math.random() * TIERS.length)];
  const description = DEFINITIONS[Math.floor(Math.random() * DEFINITIONS.length)];

  return {
    name: `${name} ${uid().slice(0, 6).toLowerCase()}`,
    description,
  };
}
